<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="mt-2 mx-0 border-none p-0">
      <b-card-header id="hoteluninvoiced-card-header" class="pl-2 pr-3 small">
        Uninvoiced Hotel Bookings
      </b-card-header>
      <b-tooltip target="hoteluninvoiced-card-header" triggers="hover">Uninvoiced Hotel Bookings</b-tooltip>
      <b-card-body class="px-0 pt-0">
        <b-table v-if="options.showtable" ref="logtable" id="logtable" striped sticky-header="205px" fixed small bordered
          :items="items" :fields="options.fields" class="gridtable my-0">
          <template v-slot:cell()="row">
            <div v-if="options.badges &&
              options.badges.find((obj) => obj.key == row.field.key)
              ">
              <span v-html="$helpers.badgeField(
                row.item,
                options.badges.find((obj) => obj.key == row.field.key),
                options
              )
                "></span>
            </div>
            <div v-else>{{ row.value }}</div>
          </template>
        </b-table>
        <b-row class="excelsheetbuttons">
          <!-- <b-col>
            <b-button-group>
              <b-button
                :pressed="true"
                squared
                size="sm"
                variant="outline-secondary"
                id="caruninvoiced_log"
              >
                <i class="fa fa-list-ol"></i>
              </b-button>
              <b-tooltip target="caruninvoiced_log" triggers="hover"
                >Show list</b-tooltip
              >
            </b-button-group>
          </b-col> -->
          <b-col class="text-right">
            <!-- <b-link
              id="caruninvoiced-start"
              :disabled="caruninvoiced.running"
              @click="action('start')"
              size="sm"
              class="mt-1 mr-2 text-primary"
            >
              <i class="fa fa-play"></i>
            </b-link>
            <b-tooltip target="caruninvoiced-start" triggers="hover"
              >Start service</b-tooltip
            >

            <b-link
              id="caruninvoiced-end"
              :disabled="!caruninvoiced.running"
              @click="action('stop')"
              size="sm"
              class="mt-1 mr-2 text-danger"
            >
              <i class="fa fa-stop"></i>
            </b-link>
            <b-tooltip target="caruninvoiced-end" triggers="hover"
              >Stop service</b-tooltip
            > -->
            <b-link id="caruninvoiced-excel" class="mt-1 excel"
              @click="$helpers.outputExcel({ items, fields: options.fields })" title="Send to excel">
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </b-link>
            <b-tooltip target="caruninvoiced-excel" triggers="hover">Grid to excel</b-tooltip>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-2">
          <b-col>
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
              <span class="small text-primary ml-2">Updating ...</span>
            </div>
            <span v-if="!busy" class="small text-primary">Showing {{ options.items.length }} uninvoiced booking(s)</span>
            <br />
            <span v-if="!busy" class="small text-primary">{{
              options.actionmessage
            }}</span>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "HotelUninvoiced",
  props: ["tile", "refresh"],
  data() {
    return {
      busy: false,
      timeout: false,
      name: "HotelUninvoiced",
      issued_at: {
        startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      options: {
        // lastrunstatus: "success",
        timestamp: "Unknown",
        running: false,
        actionmessage: "",
        status: "negative",
        showtable: true,
        format: "grid",
        fields: [
          {
            key: "confirmno",
            label: "ConfirmNo",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "passenger",
            label: "Lead Name",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "start_at",
            label: "CheckIn",
            sortable: true,
            sortDirection: "desc",
            lass: "w-150px",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "end_at",
            label: "CheckOut",
            sortable: true,
            sortDirection: "desc",
            lass: "w-150px",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          // {
          //   key: "nights",
          //   label: "Nts",
          //   sortable: true,
          //   sortDirection: "desc",
            // formatter: (value, key, item) => {
            //   let result = "";
            //   let checkout = this.$moment.unix(item.datecheckout / 1000);
            //   let checkin = this.$moment.unix(item.datecheckin / 1000);
            //   let diff = checkout.diff(checkin, "days"); // =1
            //   if (diff) {
            //     result = diff;
            //   }
            //   return result;
            // },
          // },
          {
            key: "hotelname",
            label: "Hotel",
            sortable: true,
            sortDirection: "desc",
          },
          // {
          //   key: "rooms",
          //   label: "Rooms",
          //   sortable: true,
          //   sortDirection: "desc",
          //   formatter: (value, key, item) => {
          //     let result = value;
          //     if (result) {
          //       if (result.length > 2) {
          //         result =  ".." //result.slice(0, 2);// + "...";
          //       }
          //     }
          //     return result;
          //   },
          // },
          // {
          //   key: "guests",
          //   label: "Guests",
          //   sortable: true,
          //   sortDirection: "desc",
          // },

          {
            key: "slac",
            label: "slac",
            sortable: true,
            sortDirection: "desc",
          },
          // {
          //   key: "eventcode",
          //   label: "Event",
          //   sortable: true,
          //   sortDirection: "desc",
          // },
        ],
        items: [
          {
            updated_at: this.$moment().format("x") / 1000,
            name: "Log4Net test message",
          },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            Invoiced: "primary",
            Cancelled: "danger",
            New: "info",
            Pending: "warning",
            "On Hold": "warning",
            formatter: (value, key, item) => {
              switch (value) {
                case "ID":
                  return "Invoiced";
                  break;
                case "AA":
                  return "On Hold";
                  break;
                case "CX":
                  return "Cancelled";
                  break;
                case "ST":
                  return "New";
                  break;
                case "WI":
                  return "Pending";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
      },
    };
  },
  async mounted() {
    this.$helpers.resizableColumns();
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    items() {
      return this.options.items;
    },
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Table";
      }
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: hoteluninvoiced");

      let variables = {
        issued_at: [
          this.issued_at.startDate
            ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
            : null,
          this.issued_at.endDate
            ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
      }
      this.busy = true;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query hotels ($issued_at: [String]) {
              hotels(issued_at: $issued_at) {
                id
                issued_at
                locator
                vendorcode
                # chaincode
                hotelno
                hotelname
                confirmno
                passenger
                start_at
                end_at
                nights
                rooms
                pax
                # guests
                amount
                tax 
                slac           
                eventcode
                agent
                updated_at
                updated_by
                rows
              }
            }
          `,
          variables,
        });
        console.log(response);
        if (response.data.hotels) {
          this.options.items = response.data.hotels;
        }

      } catch (error) {
        console.log(error);
      }

      this.busy = false;
      await this.$emit("refreshed");
    },
  },
};
</script>


<style></style>